import { LocalDate } from 'js-joda';
import {
  QuestionBase,
  QuestionControlOptions
} from '../question-types/question-base';

export interface DatePickerControlOptions
  extends QuestionControlOptions<string> {
  max?: string;
  min?: string;
  dateAfterOther?: string;
  dateRangeDate?: string;
  dateRangeLimit?: number;
  quarterExclusive?: string;
}
export class DatePickerQuestion extends QuestionBase<string> {
  controlType = 'datepicker';
  type = 'date';
  max: string;
  min: string;
  dateAfterOther?: string;
  dateRangeDate?: string;
  dateRangeLimit?: number;
  quarterExclusive?: string;

  constructor(options: DatePickerControlOptions) {
    super(options);

    this.value = options.value || LocalDate.now().toString();
    this.max = options.max || '9999-12-31';
    this.min = options.min || '0001-01-01';
    this.dateAfterOther = options.dateAfterOther || null;
    this.dateRangeDate = options.dateRangeDate || null;
    this.dateRangeLimit = options.dateRangeLimit;
    this.quarterExclusive = options.quarterExclusive || null;
  }
}
